import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SERVICING_ROUTES } from '@conf/routes.config';

@Component({
  selector: 'asw-boarding-certificate-search-sub-header',
  templateUrl: './boarding-certificate-search-sub-header.component.html',
  styleUrls: ['./boarding-certificate-search-sub-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoardingCertificateSearchSubHeaderComponent {
  /** 戻り先URL */
  backUrl = SERVICING_ROUTES.myBooking;
}
